import type {Component} from 'grapesjs';

/** Devtools-style green wash overlay for spacing adjustments. */

const HIGHLIGHT_GRADIENT = 'linear-gradient(to bottom, #9BECD980, #9BECD980)';

/** How long the wash lingers after the last spacing change; each change resets the timer. */
const HIGHLIGHT_DURATION_MS = 500;

interface HighlightState {
  timer: number;
  originalImage: string;
  originalClip: string;
}

const activeHighlights = new WeakMap<Component, HighlightState>();

/** Briefly washes the component's content box green to visualise a spacing change, then reverts. */
export function flashSpacingHighlight(component: Component): void {
  const el = component.getEl();
  if (!el) {
    return;
  }

  let state = activeHighlights.get(component);
  if (state) {
    window.clearTimeout(state.timer);
  } else {
    state = {timer: 0, originalImage: el.style.backgroundImage, originalClip: el.style.backgroundClip};
  }

  const baseColor = window.getComputedStyle(el).backgroundColor || 'transparent';
  el.style.backgroundImage = `${HIGHLIGHT_GRADIENT}, linear-gradient(to bottom, ${baseColor}, ${baseColor})`;
  el.style.backgroundClip = 'content-box, padding-box';

  const {originalImage, originalClip} = state;
  state.timer = window.setTimeout(() => {
    el.style.backgroundImage = originalImage;
    el.style.backgroundClip = originalClip;
    activeHighlights.delete(component);
  }, HIGHLIGHT_DURATION_MS);

  activeHighlights.set(component, state);
}
